import React from "react";
import './../../App.css';
import { Form } from 'react-bootstrap';
import Card from "react-bootstrap/Card";
import { Container } from "react-bootstrap";
import { I18nPropvider } from './../../i18nProvider';
import Button from 'react-bootstrap/Button';
import AuthService from "../../services/auth.service";
import MenuAdmin from './../menu/menuAdmin.jsx';
import { displayAlertMessage } from './../../constants/alertMessage.jsx';
import authHeader from "../../services/auth-header";

export function UploadImageBanniere({ locale }) {
    const currentUser = AuthService.getCurrentUser();

    if (currentUser == null) { //let history = useHistory();
        window.open('./login', '_self');
    }

    const publierImage = (event) => {
        const fileInput = document.getElementById('formFile');
        const positionImage = document.getElementById('positionImage').value;
        const linkImage = document.getElementById('linkImage').value;
        const formData = new FormData();

        if (typeof fileInput.files[0] !== "undefined") {
            formData.append('file', fileInput.files[0]);
            formData.append('position', positionImage);
            formData.append('linkImage', linkImage);
            formData.append('publierImage', true);

            // const options = { method: 'POST', body: formData };

            fetch('/lineup/api/image/edit/uploadImage', {
                mode: 'cors',
                method: "POST",
                headers: authHeader(),
                body: formData
            }).then(function (res) {
                if (res.ok) {
                    console.log("L'image a bien été supprimée");
                    //location.reload();
                    displayAlertMessage("alert alert-success", "L'image a bien été publiée")
                } else if (res.status == 401) {
                    displayAlertMessage("alert alert-danger", "Erreur lors de la plublication de l'image")
                }
            }, function (e) {
                console.log("Error ");
                console.log(e);
            });

            document.getElementById('formFile').value = "";
            document.getElementById('positionImage').value = "";
            document.getElementById('linkImage').value = "";
        } else {
            displayAlertMessage("alert alert-warning", "Veuillez choisir une image")
        }
    }

    const enregistrerImage = (event) => {
        const fileInput = document.getElementById('formFile');
        const positionImage = document.getElementById('positionImage').value;
        const linkImage = document.getElementById('linkImage').value;
        const formData = new FormData();

        if (typeof fileInput.files[0] !== "undefined") {
            formData.append('file', fileInput.files[0]);
            formData.append('position', positionImage);
            formData.append('linkImage', linkImage);
            formData.append('publierImage', false);

            // const options = { method: 'POST', body: formData };

            fetch('/lineup/api/image/edit/uploadImage', {
                mode: 'cors',
                method: "POST",
                headers: authHeader(),
                body: formData
            }).then(function (res) {
                if (res.ok) {
                    console.log("L'image a bien été supprimée");
                    //location.reload();
                    displayAlertMessage("alert alert-success", "L'image a bien été enregistrée")
                } else if (res.status == 401) {
                    displayAlertMessage("alert alert-danger", "Erreur lors de l'enregistrement de l'image")
                }
            }, function (e) {
                console.log("Error ");
                console.log(e);
            });
            document.getElementById('formFile').value = "";
            document.getElementById('positionImage').value = "";
            document.getElementById('linkImage').value = "";
        } else {
            displayAlertMessage("alert alert-warning", "Veuillez choisir une image")
        }
    }

    return (
        <div>
            <header className="App-header">
                <div className="bg-black" >
                    <MenuAdmin></MenuAdmin>
                </div>
            </header>
            <br />

            <div>
                <I18nPropvider locale={locale}>
                    <Container>
                        <div id="alertMessage"></div>
                        <h3>Formulaire d'ajout d'une image</h3>
                        <Card bg="white" style={{ height: 200, width: '100%' }}>
                            <Form.Group controlId="formFile" className="mb-3">
                                <Form.Label>Veuillez choisir une image</Form.Label>
                                <Form.Control type="file" />
                                <p>Veuillez vérifier la résolution de l'image avant de l'ajouter </p>
                            </Form.Group>
                            <br />
                            <Form.Group className="mb-3">
                                <Form.Label>Veuillez choisir la position de l'image lors de l'affichage de la bannière</Form.Label>
                                <Form.Select id="positionImage" className="rounded-0 shadow">
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                </Form.Select >
                            </Form.Group>
                            <br />
                            <Form.Group className="mb-3">
                            <Form.Label>Lien de l'image (doit commencer par http://)</Form.Label>
                                <Form.Control id="linkImage"
                                    as="textarea"
                                    placeholder=""
                                    style={{ height: '50px' }} defaultValue=""
                                />
                            </Form.Group>


                            <div className="row">
                                <div className="col">
                                    <Button onClick={() => enregistrerImage()}>Enregistrer</Button>
                                </div>
                                <div className="col">
                                    <button type="button" className="btn btn-success" onClick={() => publierImage()}>Publier</button>
                                </div>
                            </div>

                            {/* <div className="mb-2">
                                <Button onClick={() => imageHandler()}>Enregistrer</Button>
                            </div> */}
                        </Card>
                    </Container>
                </I18nPropvider>
            </div>
        </div >
    );
}
export default UploadImageBanniere;